import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { LanguageRoutingService } from '../../../services/language-routing.service';

export interface BreadcrumbItem {
  /** Transloco key for the crumb label. */
  labelKey: string;
  /** Unlocalized path (e.g. '/profile'). Omit for the current page. */
  link?: string;
}

/**
 * Reusable breadcrumb trail. The last item always renders as the current page
 * (non-link); earlier items with a `link` render as language-aware router links.
 */
@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslocoModule],
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent {
  @Input() items: BreadcrumbItem[] = [];

  constructor(protected languageRoutingService: LanguageRoutingService) {}
}
